import { combineReducers } from 'redux';

import commonReducers from '../../common/reducers';
import isPostInPreview from '../../common/store/is-post-in-preview/is-post-in-preview-reducer';
import loadingBar from '../../common/store/loading-bar/loading-bar-reducer';
import recentPostsIds from '../../recent-posts/reducers/recent-posts-ids';
import lastPostSlug from './last-post-slug';
import preloadedForms from './preloaded-forms';
import pricingPlansUrl from './pricing-plans-url';
import readingSessionId from './reading-session-id';
import relatedPosts from './related-posts';

export const postPageReducers = {
  ...commonReducers,
  isPostInPreview,
  lastPostSlug,
  recentPostsIds,
  relatedPosts,
  loadingBar,
  readingSessionId,
  pricingPlansUrl,
  preloadedForms,
};

export default combineReducers(postPageReducers);
